import { useContext, useEffect, useState } from 'react'
import { UIContext } from 'Context/UI'
import { TableContext } from 'Context/Table'
import { MOCK_DATA_DETAIL } from 'Data/mockMarketplaceOrder'
import { isMobileDevice } from '_metronic/assets/ts/_utils'

import ProductCell from './Components/ProductCell'
import QuantityCell from './Components/QuantityCell'
import PriceCell from './Components/PriceCell'
import TotalPriceCell from './Components/TotalPriceCell'

const ViewModel = () => {
	const { setShowContentToolbar, setCustomContentToolbar } = useContext(UIContext)
	const { updatePagination, updateLoading, updateSorting, updateError } = useContext(TableContext)

	const [isLoading, setIsLoading] = useState<boolean>(false)

	const setupTable = () => {
		updatePagination(false)
		updateSorting('product', false)
	}

	const setupUI = () => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)
	}

	const resetUI = () => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)
	}

	const fetchData = () => {
		setIsLoading(true)
		updateLoading(true)
		updateError(false)

		setTimeout(() => {
			setIsLoading(false)
			updateLoading(false)
		}, 1000)
	}

	const TABLE_CONFIGS: any[] = [
		{
			Header: 'สินค้า',
			accessor: 'product',
			minWidth: !isMobileDevice() ? 600 : 150,
			width: !isMobileDevice() ? 600 : 150,
			Cell: ProductCell,
		},
		{
			headerRight: true,
			Header: 'จำนวน',
			accessor: 'quantity',
			width: 140,
			minWidth: 140,
			Cell: QuantityCell,
		},
		{
			headerRight: true,
			Header: 'ราคาต่อหน่วย',
			accessor: 'product.price',
			width: 200,
			minWidth: 200,
			Cell: PriceCell,
		},
		{
			headerRight: true,
			Header: 'ราคารวม',
			accessor: 'totalPrice',
			width: 200,
			minWidth: 200,
			Cell: TotalPriceCell,
		},
	]

	useEffect(() => {
		setupTable()
		setupUI()

		return () => {
			resetUI()
		}
		// eslint-disable-next-line
	}, [])

	useEffect(() => {
		fetchData()
		// eslint-disable-next-line
	}, [])

	return {
		isLoading,
		data: MOCK_DATA_DETAIL,
		TABLE_CONFIGS,
	}
}

export default ViewModel
